import Head from 'next/head';
import React from 'react';

function Home() {
  return (
    <>
      <Head>
        <title>Biocentury GraphCMS UI</title>
      </Head>
      <main className="bg-white">
        <div className="mx-auto max-w-7xl py-16 px-4 sm:py-24 sm:px-6 lg:px-8">
          <div className="text-center">
            <h2 className="text-lg font-semibold text-secondary-500">
              BIOCENTURY
            </h2>
            <p className="mt-1 text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl lg:text-6xl">
              Hygraph UI Extensions
            </p>
            <p className="mx-auto mt-5 max-w-xl text-xl text-gray-500">
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolorum,
              fuga est! Esse nesciunt voluptas porro blanditiis veniam quisquam!
              Quisquam accusantium modi incidunt, tempore voluptate vero totam
              quia. Reprehenderit, laboriosam sequi?
            </p>
          </div>
        </div>
      </main>
    </>
  );
}

export default Home;
